export default "__VITE_ASSET__CZg1GuKg__"